import { useLayoutEffect } from "react";

/**
 * Hide the legacy section-tabs bar (#sub-nav-header) while `shouldHide` is true and
 * restore it on unmount. The bar is server-rendered chrome that lives outside React,
 * so we toggle it imperatively; useLayoutEffect runs before paint to avoid a flash on
 * a full page load. (PY-13586)
 */
export const useHideSubNav = (shouldHide: boolean): void => {
	useLayoutEffect(() => {
		if (!shouldHide) return;
		const subNav = document.getElementById("sub-nav-header");
		if (!subNav) return;
		subNav.style.display = "none";
		return () => {
			subNav.style.display = "";
		};
	}, [shouldHide]);
};
